import styled, { css } from 'styled-components'
import { H2, H1 } from '@raysync/common/components'
import { hideAtMobile, Media } from '@raysync/common/theme'
import { LargeWrapper, Link, Column } from '@raysync/common/components'
export const PostWrapper = styled(LargeWrapper)`
  margin-bottom: 60px;
  ${Media.phone`
    padding-bottom: 1rem;
  `}
`

export const SideBarTitle = styled(H2)`
  ${({ theme: { color, spacing } }) => css`
    padding: 0 ${spacing.small};
    margin: 1rem 0 1.4rem;
    border-left: 4px solid ${color.secondary};
    line-height: 24px;
    font-size: 16px;
    color: #15254a;
  `}
`

export const PostImg = styled.img`
  width: 100%;
`
export const PostTitle = styled(H1)`
  ${({ theme: { color, typography } }) => css`
    color: ${color.textDarkPlus};
    font-weight: normal;
    font-size: 20px;
    line-height: 30px;
    font-weight: bold;
    max-width: 750px;
  `}
`
export const Time = styled.div`
  font-size: 16px;
`

export const PostSubTitle = styled.div`
  ${({ theme: { color, typography, spacing } }) => css`
    display: flex;
    color: ${color.textLight};
    margin: 16px 0 26px;
    font-size: ${typography.textThin};
    max-width: 750px;
    span {
      margin-right: ${spacing.small};
    }
    svg {
      margin-right: 5px;
      color: ${color.textLight};
    }
  `}
`

export const PostDate = styled.p`
  ${({ theme: { color, typography } }) => css`
    color: ${color.primary};
    margin: 10px 0 20px;
    font-size: ${typography.textThin};
    svg {
      margin-right: 5px;
    }
  `}
`
export const LinkToPost = styled.p`
  ${({ theme: { color, typography } }) => css`
    color: ${color.textMiddle};
    font-size: 16px;
    margin-bottom: 5px;
    line-height: 24px;
    a {
      display: inline;
      font-size: 16px;
      color: ${color.secondary};
      :hover {
        text-decoration: underline;
      }
    }
    ${Media.phone`
      font-size: .3rem;
    `}
  `}
`
export const SidebarHeader = styled.div``

export const Span = styled.span`
  margin-right: 10px;
`
export const Tag = styled(Link)`
  ${({ theme: { color, typography, spacing } }) => css`
    color: ${color.secondary};
    font-size: ${typography.textSmall};
    &:not(:last-child) {
      margin-right: ${spacing.small};
    }
  `}
`
export const LargeColumn = styled(Column)`
  padding-right: 50px;
  ${Media.phone`
    padding-right: 0;
  `}
`

export const DescColumn = styled(Column)`
  ${hideAtMobile}
`
